<template>
  <div class="w-100 bg-white">
    <!-- NAVBAR -->
    <HomeNavbar
      @shareClick="shareClick"
      @callClick="callClick"
      @goToBookingPage="goToBookingPage" />

    <!-- HOTEL NAME -->
    <div class="pt-5">
      <div class="ga-container fluid d-block pt-5">
        <div class="w-100" v-if="is_load.top">
          <b-row class="slim-grid-row mb-2">
            <b-col cols="12" class="mb-2">
              <b-skeleton width="40%" height="56px"></b-skeleton>
            </b-col>
            <b-col cols="2">
              <b-skeleton width="100%" height="30px"></b-skeleton>
            </b-col>
            <b-col cols="4">
              <b-skeleton width="100%" height="30px"></b-skeleton>
            </b-col>
          </b-row>
          <b-row class="slim-grid-row">
            <b-col cols="8">
              <b-skeleton width="100%" height="400px"></b-skeleton>
            </b-col>
            <b-col cols="4">
              <b-row class="slim-grid-row">
                <b-col cols="6" class="mb-2">
                  <b-skeleton
                    width="100%"
                    height="192px"
                    class="mb-0"></b-skeleton>
                </b-col>
                <b-col cols="6" class="mb-2">
                  <b-skeleton
                    width="100%"
                    height="192px"
                    class="mb-0"></b-skeleton>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <b-skeleton
                    width="100%"
                    height="192px"
                    class="mb-0"></b-skeleton>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <template v-else>
          <h1 class="mb-1 pt-3 heading-4-1 text-34 font-extrabold">
            {{ getMerchant.name }}
          </h1>
          <div class="d-flex">
            <div v-if="getMerchant.star > 0" class="d-flex align-items-center">
              <svg style="margin-top: 2px" class="flex-0 me-6" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="18" height="18" rx="2" fill="#F7941D"></rect>
                <path d="M12.452 10.353C12.3009 10.4994 12.2315 10.7112 12.2659 10.9188L12.7845 13.7888C12.8283 14.0321 12.7256 14.2783 12.522 14.4188C12.3225 14.5647 12.0571 14.5822 11.8395 14.4655L9.25594 13.118C9.16611 13.0702 9.06636 13.0445 8.96428 13.0416H8.80619C8.75136 13.0498 8.69769 13.0673 8.64869 13.0941L6.06453 14.448C5.93678 14.5122 5.79211 14.5349 5.65036 14.5122C5.30503 14.4468 5.07461 14.1178 5.13119 13.7708L5.65036 10.9008C5.68478 10.6913 5.61536 10.4784 5.46428 10.3297L3.35786 8.28801C3.18169 8.11709 3.12044 7.86042 3.20094 7.62884C3.27911 7.39784 3.47861 7.22926 3.71953 7.19134L6.61869 6.77076C6.83919 6.74801 7.03286 6.61384 7.13203 6.41551L8.40953 3.79634C8.43986 3.73801 8.47894 3.68434 8.52619 3.63884L8.57869 3.59801C8.60611 3.56767 8.63761 3.54259 8.67261 3.52217L8.73619 3.49884L8.83536 3.45801H9.08094C9.30028 3.48076 9.49336 3.61201 9.59428 3.80801L10.8887 6.41551C10.982 6.60626 11.1634 6.73867 11.3729 6.77076L14.272 7.19134C14.517 7.22634 14.7218 7.39551 14.8029 7.62884C14.8793 7.86276 14.8134 8.11942 14.6337 8.28801L12.452 10.353Z" fill="white"></path>
              </svg>
              <p class="mb-0 body-1 ml-2">{{ getMerchant.star }} Stars {{ getMerchant.merchant_category_name ? getMerchant.merchant_category_name : "" }}</p>
            </div>
            <div class="d-flex text-truncate">
              <svg style="margin-top: 10px" class="flex-0 mx-3" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="4" height="4" rx="2" fill="#BEBEBE"></rect>
              </svg>  
              <svg style="margin-top: 2px" class="me-6 flex-0" width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.91602 8.59846C2.91602 4.76523 6.11925 1.66699 9.99389 1.66699C13.8794 1.66699 17.0827 4.76523 17.0827 8.59846C17.0827 10.5301 16.3802 12.3233 15.2239 13.8433C13.9484 15.5199 12.3761 16.9807 10.6065 18.1273C10.2014 18.3923 9.83591 18.4123 9.39139 18.1273C7.61163 16.9807 6.03942 15.5199 4.77477 13.8433C3.61767 12.3233 2.91602 10.5301 2.91602 8.59846ZM7.66121 8.81428C7.66121 10.0984 8.70906 11.1084 9.99389 11.1084C11.2796 11.1084 12.3375 10.0984 12.3375 8.81428C12.3375 7.54015 11.2796 6.48102 9.99389 6.48102C8.70906 6.48102 7.66121 7.54015 7.66121 8.81428Z"
                  fill="#AAAAAA"></path>
              </svg>
              <p class="mb-0 body-1 ml-2 cursor-pointer" @click="$smoothScroll('mapSection')">
                <u>{{ getMerchant.address }}</u>
              </p>
            </div>
          </div>
          <!-- IMAGE -->
          <div class="mt-4" v-if="getMerchant.merchant_images.length > 0">
            <div class="row slim-grid-row-1">
              <div class="col-12" v-if="getMerchant.merchant_images.length < 4">
                <div
                  v-if="getMerchant.merchant_images.length == 1"
                  class="w-100 h-400">
                  <img
                    @click="
                      goToDetailSlider(getMerchant.merchant_images[0]);
                      showGallery(true);
                    "
                    :src="getMerchant.merchant_images[0].image_url"
                    class="img-fit cursor-pointer h-400 radius-8"
                    :alt="getMerchant.name" />
                </div>
                <flickity v-else ref="flickity" :options="$fullSliderOption">
                  <div
                    class="carousel-cell w-100"
                    :id="slider_merchant.id"
                    v-for="slider_merchant in getMerchant.merchant_images">
                    <div class="w-100 h-400">
                      <img
                        @click="
                          goToDetailSlider(slider_merchant);
                          showGallery(true);
                        "
                        :src="slider_merchant.image_url"
                        class="img-fit h-400 radius-8 cursor-pointer"
                        :alt="getMerchant.name" />
                    </div>
                  </div>
                </flickity>
              </div>
              <template v-else>
                <div class="col-xl-8 col-md-7">
                  <img
                    @click="
                      goToDetailSlider(getMerchant.merchant_images[0]);
                      showGallery(true);
                    "
                    :src="getMerchant.merchant_images[0].image_url"
                    class="w-100 img-slider-1 h-400 cursor-pointer"
                    :alt="getMerchant.name" />
                </div>
                <div class="col-xl-4 col-md-5 h-400 overflow-hidden">
                  <div class="row slim-grid-row-1">
                    <div class="col-12 mb-2">
                      <div class="row slim-grid-row-1">
                        <div class="col-6">
                          <img
                            @click="
                              goToDetailSlider(getMerchant.merchant_images[1]);
                              showGallery(true);
                            "
                            :src="getMerchant.merchant_images[1].image_url"
                            class="w-100 img-slider-2 cursor-pointer"
                            :alt="getMerchant.name" />
                        </div>
                        <div class="col-6">
                          <img
                            @click="
                              goToDetailSlider(getMerchant.merchant_images[2]);
                              showGallery(true);
                            "
                            :src="getMerchant.merchant_images[2].image_url"
                            class="w-100 img-slider-3 cursor-pointer"
                            :alt="getMerchant.name" />
                        </div>
                      </div>
                    </div>
                    <div class="col-12 position-relative">
                      <img
                        @click="
                          goToDetailSlider(getMerchant.merchant_images[3]);
                          showGallery(true);
                        "
                        :src="getMerchant.merchant_images[3].image_url"
                        class="w-100 img-slider-4 cursor-pointer"
                        :alt="getMerchant.name" />
                      <button
                        @click="showGallery(true)"
                        v-if="getMerchant.merchant_images.length > 4"
                        type="button"
                        class="g-btn bg-white g-btn-sm position-absolute bottom-0 right-0 px-3 cursor-pointer"
                        style="bottom: 18px; right: 24px">
                        {{ $t('general.view-all') }}
                        {{ getMerchant.merchant_images.length }}
                        {{ $t('hotel.concierge.images') }}
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="ga-container fluid mt-5">
      <div class="w-100">
        <div class="row no-gutters mb-5">
          <div class="col-8">
            <div class="w-100 pr-xl-0 pr-md-5">
              <!-- RESERVATION DETAIL -->
              <div class="w-100">
                <div
                  class="pb-5 mb-5 border-b-semi-grey"
                  v-if="is_load.reservation">
                  <b-row class="slim-grid-row">
                    <b-col cols="12" class="mb-3">
                      <b-skeleton width="20%" height="40px"></b-skeleton>
                    </b-col>
                    <b-col cols="12">
                      <b-card body-class="p-3">
                        <b-row no-gutters>
                          <b-col cols="4" class="align-self-center">
                            <b-row class="slim-grid-row">
                              <b-col cols="6">
                                <b-skeleton
                                  width="100%"
                                  height="57px"></b-skeleton>
                              </b-col>
                              <b-col cols="6">
                                <b-skeleton
                                  width="100%"
                                  height="15px"></b-skeleton>
                                <b-skeleton
                                  width="80%"
                                  height="15px"></b-skeleton>
                                <b-skeleton
                                  width="60%"
                                  height="15px"></b-skeleton>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="3" offset="5" class="align-self-center">
                            <b-skeleton width="100%" height="40px"></b-skeleton>
                          </b-col>
                          <b-col cols="12" class="my-3">
                            <div class="w-100 border-2-bottom-dashed"></div>
                          </b-col>
                          <b-col cols="4">
                            <b-skeleton width="30%" height="15px"></b-skeleton>
                            <b-skeleton width="50%" height="20px"></b-skeleton>
                          </b-col>
                          <b-col cols="4">
                            <b-skeleton width="30%" height="15px"></b-skeleton>
                            <b-skeleton width="50%" height="20px"></b-skeleton>
                          </b-col>
                          <b-col cols="4">
                            <b-skeleton width="30%" height="15px"></b-skeleton>
                            <b-skeleton width="50%" height="20px"></b-skeleton>
                          </b-col>
                          <b-col cols="12" class="my-3">
                            <div class="w-100 border-2-bottom-dashed"></div>
                          </b-col>
                          <b-col cols="12">
                            <b-skeleton width="70%" height="20px"></b-skeleton>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>
                <template v-else>
                  <div
                    class="pb-5 mb-5 border-b-semi-grey"
                    v-if="data_parent.reservation.id">
                    <p class="heading-5 mb-4">Reservation Detail</p>
                    <div class="w-100 border-semi-grey radius-12 p-3">
                      <div class="row no-gutters">
                        <div class="col-2 align-self-center">
                          <div class="w-100 pr-3">
                            <div
                              class="w-100 bg-orange text-center radius-12"
                              style="padding: 15px 0px">
                              <i
                                class="simple-icon-home text-24 text-white"></i>
                            </div>
                          </div>
                        </div>
                        <div
                          class="align-self-center"
                          :class="
                            data_parent.reservation.status == 'SUBMIT_FORM' ||
                            data_parent.reservation.status == 'PRE_CHECKIN' ||
                            data_parent.reservation.status == 'CHECKIN' ||
                            (getMerchant.reservation_detail_show_bill &&
                              isCurrentUserSameWithRsvUser)
                              ? 'col-7'
                              : 'col-12'
                          ">
                          <p
                            class="mb-0 body-1-2"
                            :class="{
                              'text-danger':
                                data_parent.reservation.room_type.name ==
                                'Unallocated Room Type',
                            }">
                            {{ data_parent.reservation.room_type.name }}
                          </p>
                          <div class="w-100 no-ws">
                            <p
                              class="mb-0 d-inline-block align-middle body-2-2-1 mr-2">
                              Room :
                            </p>
                            <p
                              class="mb-0 d-inline-block align-middle body-2-1"
                              :class="{
                                'text-danger':
                                  data_parent.reservation.room.name ==
                                  'Unallocated',
                              }">
                              {{ data_parent.reservation.room.name }}
                            </p>
                          </div>
                          <p class="mb-0 body-2-1 text-info">
                            Folio
                            {{
                              data_parent.reservation.folio_number != ''
                                ? `#${data_parent.reservation.folio_number}`
                                : '#'
                            }}
                          </p>
                        </div>
                        <div
                          class="col-3 align-self-center"
                          v-if="
                            data_parent.reservation.status == 'SUBMIT_FORM' ||
                            data_parent.reservation.status == 'PRE_CHECKIN' ||
                            data_parent.reservation.status == 'CHECKIN' ||
                            (getMerchant.reservation_detail_show_bill &&
                              isCurrentUserSameWithRsvUser)
                          ">
                          <div class="w-100 pl-3">
                            <button
                              v-if="
                                data_parent.reservation.status ==
                                  'SUBMIT_FORM' ||
                                data_parent.reservation.status == 'PRE_CHECKIN'
                              "
                              type="button"
                              class="g-btn g-btn-primary w-100"
                              :class="
                                getMerchant.reservation_detail_show_bill &&
                                isCurrentUserSameWithRsvUser
                                  ? 'g-btn-sm mb-2'
                                  : 'g-btn-md'
                              "
                              @click="checkStatus()">
                              Check Status
                            </button>

                            <button
                              v-if="
                                getMerchant.reservation_detail_show_bill &&
                                isCurrentUserSameWithRsvUser
                              "
                              type="button"
                              class="g-btn g-btn-secondary-outline w-100"
                              :class="
                                data_parent.reservation.status ==
                                  'SUBMIT_FORM' ||
                                data_parent.reservation.status == 'PRE_CHECKIN'
                                  ? 'g-btn-sm'
                                  : 'g-btn-md'
                              "
                              @click="openGuestBill()">
                              Guest Bill
                            </button>
                          </div>
                        </div>
                        <div class="col-12 my-3">
                          <div class="w-100 border-2-bottom-dashed"></div>
                        </div>
                        <div class="col-4">
                          <p class="mb-0 body-2-2-1">Check in</p>
                          <p class="mb-0 body-2-1">
                            {{
                              $formatDate(
                                data_parent.reservation.arrival_date,
                                'YYYY-MM-DD'
                              )
                            }}
                          </p>
                        </div>
                        <div class="col-4">
                          <p class="mb-0 body-2-2-1">Check out</p>
                          <p class="mb-0 body-2-1">
                            {{
                              $formatDate(
                                data_parent.reservation.departure_date,
                                'YYYY-MM-DD'
                              )
                            }}
                          </p>
                        </div>
                        <div class="col-4">
                          <p class="mb-0 body-2-2-1">Status</p>
                          <p
                            class="mb-0 body-2-1"
                            :class="reservation_status.text_color">
                            {{ reservation_status.title }}
                          </p>
                        </div>
                        <div class="col-12 my-3">
                          <div class="w-100 border-b-semi-grey"></div>
                        </div>
                        <div class="col-12">
                          <p class="mb-0 body-2-2-1">
                            {{ reservation_status.description }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- ROOM TYPE -->
              <RoomTypePreview
                v-if="
                  getMerchant.use_booking_engine &&
                  getMerchant.is_show_room_type
                "
                data_source="parent"
                :parent_data="data_parent.room_type"
                :is_load="is_load.room_type"></RoomTypePreview>

              <!-- MENU SERVICE -->
              <div class="w-100">
                <div
                  class="pb-5 mb-5 border-b-semi-grey"
                  v-if="is_load.small_menu">
                  <b-row class="slim-grid-row">
                    <b-col cols="12" class="mb-3">
                      <b-skeleton width="20%" height="40px"></b-skeleton>
                      <b-skeleton width="50%" height="20px"></b-skeleton>
                    </b-col>
                    <b-col cols="6" v-for="i in 2" :key="i">
                      <b-card no-body img-left>
                        <b-skeleton-img
                          no-aspect
                          width="35%"
                          height="95px"
                          card-img="left"></b-skeleton-img>
                        <b-card-body class="p-2">
                          <b-skeleton width="40%" height="20px"></b-skeleton>
                          <b-skeleton
                            width="60%"
                            height="15px"
                            class="mb-2"></b-skeleton>
                          <b-skeleton
                            width="20%"
                            height="20px"
                            class="d-table ml-auto mb-0"></b-skeleton>
                        </b-card-body>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>

                <template v-else>
                  <div
                    class="w-100 pb-5 mb-5 border-b-semi-grey"
                    v-if="data_parent.menu.length > 0">
                    <p class="heading-5 mb-1">
                      {{ $t('hotel.concierge.fitur.book-our-services') }}
                    </p>
                    <p class="body-2-2-1 sub-title text-15 mb-4">
                      {{ $t('hotel.concierge.fitur.fitur-desc') }}
                    </p>
                    <div class="row">
                      <div
                        class="col-6"
                        v-for="menu_service in data_parent.menu"
                        v-if="menu_service.service_type == 'MERCHANT_POS'">
                        <div
                          class="row border-semi-grey radius-12 mb-3 no-gutters">
                          <div class="col-4 radius-12" style="height: 95px">
                            <img
                              v-if="
                                menu_service.merchant_pos.slider.length == 1
                              "
                              :src="
                                menu_service.merchant_pos.slider[0].image_url
                              "
                              class="img-fit radius-12-l" />
                            <flickity
                              v-else
                              ref="flickity"
                              class="mb-3"
                              :options="freeScrollSlider">
                              <div
                                class="carousel-cell w-100"
                                style="height: 95px"
                                v-for="menu_slider in menu_service.merchant_pos
                                  .slider">
                                <img
                                  :src="menu_slider.image_url"
                                  class="img-fit radius-12-l" />
                              </div>
                            </flickity>
                          </div>
                          <div class="col-8">
                            <div
                              class="w-100 px-3 py-2 cursor-pointer"
                              @click="
                                detailModuleClick(
                                  menu_service.merchant_pos.code
                                )
                              ">
                              <p class="body-1-2 mb-1 text-truncate">
                                {{ menu_service.merchant_pos.tagline }}
                              </p>
                              <p class="body-2-2-1 mb-0 text-truncate">
                                {{ menu_service.merchant_pos.sub_tagline }}
                              </p>
                              <div class="w-100 mt-1">
                                <div
                                  class="d-table link-green-arrow ml-auto"
                                  @click="
                                    detailModuleClick(
                                      menu_service.merchant_pos.code
                                    )
                                  ">
                                  <p
                                    class="mb-0 d-inline-block aling-middle text-12">
                                    {{ $t('hotel.concierge.fitur.read-more') }}
                                  </p>
                                  <i
                                    class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-10"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- MENU SERVICE PREVIEW -->
              <div class="w-100">
                <div
                  v-if="is_load.big_menu"
                  class="pb-5 mb-5 border-b-semi-grey">
                  <b-row class="slim-grid-row">
                    <b-col cols="12" class="mb-3">
                      <b-skeleton width="20%" height="40px"></b-skeleton>
                      <b-skeleton width="50%" height="20px"></b-skeleton>
                    </b-col>
                    <b-col cols="12">
                      <b-card>
                        <b-row class="mb-4">
                          <b-col cols="12" class="mb-3">
                            <b-skeleton width="20%" height="25px"></b-skeleton>
                            <b-skeleton width="50%" height="15px"></b-skeleton>
                          </b-col>
                          <b-col cols="8">
                            <b-skeleton-img
                              no-aspect
                              width="100%"
                              height="185px"></b-skeleton-img>
                          </b-col>
                          <b-col cols="4">
                            <b-skeleton-img
                              no-aspect
                              width="100%"
                              height="185px"></b-skeleton-img>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" class="mb-2">
                            <b-skeleton width="20%" height="25px"></b-skeleton>
                            <b-skeleton width="50%" height="15px"></b-skeleton>
                          </b-col>
                          <b-col cols="3" v-for="i in 4" :key="i">
                            <b-skeleton-img
                              no-aspect
                              width="100%"
                              height="150px"></b-skeleton-img>
                            <b-skeleton
                              width="40%"
                              height="20px"
                              class="mt-3"></b-skeleton>
                            <b-skeleton width="50%" height="15px"></b-skeleton>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>
                <template v-else>
                  <div
                    class="mb-5 pb-5 border-b-semi-grey w-100"
                    v-for="(menu_preview, index) in data_parent.preview"
                    v-if="menu_preview.service_type == 'MERCHANT_POS'">
                    <p class="heading-5 mb-1">{{ menu_preview.tagline }}</p>
                    <p class="body-2-2-1 sub-title text-15 mb-4">
                      {{ menu_preview.sub_tagline }}
                    </p>
                    <RoomDiningPreview
                      v-if="
                        menu_preview.merchant_pos.code ==
                        'concierge-room-dining'
                      "
                      type="desktop"
                      :data="menu_preview" />
                    <ThingsToDoPreview
                      v-if="
                        menu_preview.merchant_pos.code == 'concierge-experience'
                      "
                      type="desktop"
                      :data="menu_preview.merchant_pos" />
                    <SpaPreview
                      v-if="menu_preview.merchant_pos.code == 'concierge-spa'"
                      type="desktop"
                      :data="menu_preview.merchant_pos" />
                    <LaundryPreview
                      v-if="
                        menu_preview.merchant_pos.code == 'concierge-laundry'
                      "
                      type="desktop"
                      :data="menu_preview" />
                  </div>
                  <div
                    class="w-100 pb-5"
                    v-for="(upselling, index) in data_parent.preview"
                    v-if="upselling.service_type == 'UPSELLING_PRODUCT_GROUP'">
                    <p class="sub-heading-1-1 mb-1 text-semi-dark">
                      {{ upselling.tagline }}
                    </p>
                    <p class="body-2-2-1 mb-3 sub-title">
                      {{ upselling.sub_tagline }}
                    </p>
                    <VoucherPreview type="desktop" :data="upselling" />
                  </div>
                </template>
              </div>

              <!-- BOTTOM AREA -->
              <div class="w-100">
                <div v-if="is_load.bottom" class="pb-5 mb-5 border-b-semi-grey">
                  <b-row class="slim-grid-row">
                    <b-col cols="12" class="mb-3">
                      <b-skeleton width="20%" height="40px"></b-skeleton>
                      <b-skeleton width="50%" height="20px"></b-skeleton>
                    </b-col>
                    <b-col cols="6" v-for="i in 2" :key="i">
                      <b-card no-body img-left>
                        <b-skeleton-img
                          no-aspect
                          width="35%"
                          height="58px"
                          card-img="left"></b-skeleton-img>
                        <b-card-body class="p-2">
                          <b-skeleton width="40%" height="20px"></b-skeleton>
                          <b-skeleton
                            width="60%"
                            height="15px"
                            class="mb-0"></b-skeleton>
                        </b-card-body>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>

                <template v-else>
                  <!-- SOCIAL MEDIA -->
                  <div
                    class="mb-5 pb-5 border-b-semi-grey w-100"
                    v-if="getMerchant.social_media.length > 0">
                    <p class="heading-5 mb-1 text-semi-dark">
                      {{ getMerchant.merchant_social_media_title }}
                    </p>
                    <p class="body-2-2-1 sub-title text-15 mb-4">
                      {{ getMerchant.merchant_social_media_subtitle }}
                    </p>
                    <div class="row">
                      <div
                        class="col-6 mb-2"
                        v-for="sosmed in getMerchant.social_media">
                        <CustomUrl
                          type="social_media"
                          :data="sosmed"></CustomUrl>
                      </div>
                    </div>
                  </div>

                  <!-- CUSTOM URL -->
                  <div
                    class="mb-5 pb-5 border-b-semi-grey w-100"
                    v-if="getMerchant.merchant_link.length > 0">
                    <p class="heading-5 mb-1 text-semi-dark">
                      {{ getMerchant.merchant_link_title }}
                    </p>
                    <p class="body-2-2-1 sub-title text-15 mb-4">
                      {{ getMerchant.merchant_link_subtitle }}
                    </p>
                    <div class="row">
                      <div
                        class="col-6 mb-2"
                        v-for="custom_url in getMerchant.merchant_link">
                        <CustomUrl type="custom" :data="custom_url"></CustomUrl>
                      </div>
                    </div>
                  </div>

                  <!-- OTHER INFORMATION -->
                  <div class="mb-5 pb-5 border-b-semi-grey w-100">
                    <div
                      class="w-100"
                      v-if="
                        getMerchant.check_in_time_start != '' &&
                        getMerchant.check_out_time_start != ''
                      ">
                      <p class="mb-3 sub-heading-1-1">
                        {{ $t('general.about-accommodation') }}
                      </p>
                      <div class="mb-3" v-if="getMerchant.description != ''">
                        <!-- <p class="mb-2 body-3-3 text-16 font-bold">{{$t('general.description')}}</p> -->
                        <div
                          class="mb-4 body-3-3 text-15 font-medium text-truncate-10 html-desc"
                          v-html="getMerchant.description"></div>
                        <p
                          class="mb-0 body-2-1 d-table cursor-pointer text-green border-bottom-green"
                          @click="
                            togglePopupInfo(
                              $t('general.about-accommodation'),
                              getMerchant.description
                            )
                          ">
                          Read More
                        </p>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <div
                            class="border-semi-grey radius-12 py-2 text-center">
                            <p class="mb-0 body-2-2-1">
                              {{ $t('hotel.check-in-time') }}
                            </p>
                            <p class="mb-0 body-1-4">
                              {{ formatTime(getMerchant.check_in_time_start) }}
                            </p>
                            <p class="mb-0 body-3-3-1">
                              UTC{{ getMerchantTimezone.offset }}
                            </p>
                          </div>
                        </div>
                        <div class="col-6">
                          <div
                            class="border-semi-grey radius-12 py-2 text-center">
                            <p class="mb-0 body-2-2-1">
                              {{ $t('hotel.check-out-time') }}
                            </p>
                            <p class="mb-0 body-1-4">
                              {{ formatTime(getMerchant.check_out_time_end) }}
                            </p>
                            <p class="mb-0 body-3-3-1">
                              UTC{{ getMerchantTimezone.offset }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- FACILITIES -->
                  <div
                    class="mb-5 pb-5 border-b-semi-grey w-100"
                    v-if="getMerchant.facilities.length > 0">
                    <p class="mb-3 heading-5">{{ $t('general.facilities') }}</p>
                    <div class="row slim-grid-row">
                      <div
                        class="col-sm-3 col-6 mb-3"
                        v-for="(facility, index) in facilitiesInline">
                        <Facility :data="facility"></Facility>
                      </div>
                      <div v-if="getMerchant.facilities.length > 8" class="col-sm-3 col-6 mb-3">
                        <div v-b-modal.facilities-modal class="w-100 facility-home h-100 p-3 cursor-pointer">
                          <p class="mb-2 font-lato text-22 d-block">+{{getMerchant.facilities.length - 7}}</p>
                          <div class="d-flex align-items-center">
                            <p class="mb-0 text d-inline-block align-middle">See all facilities</p>
                            <svg class="ml-3" width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.96961 6.41928C3.17425 6.20344 3.49449 6.18382 3.72015 6.36042L3.7848 6.41928L8.40361 11.2911L13.0224 6.41928C13.2271 6.20344 13.5473 6.18382 13.7729 6.36042L13.8376 6.41928C14.0422 6.63513 14.0608 6.97289 13.8934 7.2109L13.8376 7.27909L8.8112 12.5806C8.60655 12.7965 8.28632 12.8161 8.06066 12.6395L7.99601 12.5806L2.96961 7.27909C2.7445 7.04166 2.7445 6.65671 2.96961 6.41928Z" fill="#222222"></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- MAP -->
                  <div class="w-100 border-b-semi-grey pb-4 position-relative" ref="map_section">
                    <span id="mapSection" class="position-absolute" style="top: -100px;" />
                    <p class="mb-2 heading-5">{{ $t('general.location') }}</p>
                    <p class="mb-3 body-2-2">
                      <img
                        src="../../assets/img/icon/location-dark.png"
                        class="mr-2"
                        width="15" />
                      {{ getMerchant.address }}
                    </p>
                    <div class="w-100 pb-4">
                      <iframe v-if="$isNotEmptyV2(getMerchant.location_embed_map)" :src="getMerchant.location_embed_map" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                      <ShowGmaps v-else />
                    </div>
                  </div>

                  <!-- PARTNER PREVIEW -->
                  <div class="pt-5" v-if="getMerchant.verified_by.length > 0">
                    <PartnerPreview></PartnerPreview>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="pl-xl-5 pl-md-0 ml-xl-5 ml-md-0 sticky top-100">
              <!-- UI REDIRECT -->
              <!-- <div class="w-100 border-semi-grey radius-12 mb-4">
								<template v-if="data_parent.promo.length > 0">
						      <router-link :to="'/'+getMerchant.code+'/promo'">
								    <div class="promo-mobile rounded-top-12 position-relative px-4 py-3">
											<div class="row no-gutters">
												<div class="col-1">
													<div class="d-inline-block icon">
														<img src="../../assets/img/icon/menu-navbar/Promo.svg" alt="Promo" width="42">
													</div>
												</div>
												<div class="col-10">
													<div class="d-inline-block ml-3 pl-1">
														<p class="mb-0 body-1-2 text-16 font-bold">{{$t('hotel.concierge.fitur.there-are')}} {{data_parent.promo.length}} {{$t('hotel.concierge.fitur.interesting-promos')}}</p>
														<p class="mb-0 body-1-2 text-12 font-regular">{{$t('hotel.concierge.fitur.click-to-get-attractive-promos')}}</p>
													</div>
												</div>
												<div class="col-1 text-right">
													<img src="../../assets/img/icon/back-arrow.png" class="mt-3 transform-180" alt="Promo" width="12">
												</div>
												<div class="bg">
													<img src="../../assets/img/icon/menu-navbar/Promo-Bg.svg" alt="Promo" class="w-100">
												</div>
											</div>
								    </div>
								  </router-link>
								</template>
								<div class="p-4">
									<div class="row">
										<div class="col-12">
											<p class="heading-5 mb-2 text-26">{{$t('hotel.concierge.fitur.book-our-rooms')}}</p>
										</div>
										<div class="col-6 align-self-center">
											<p class="body-2-2 mb-0">{{$t('hotel.starting-from')}}</p>
											<p class="mb-0 body-2-2-3 text-24 font-bold text-orange">{{$formatCurrency(data_parent.lowest_price)}}</p>
										</div>
										<div class="col-6">
											<div class="w-100 radius-12 bg-green p-3 cursor-pointer text-center">
												<p class="mb-0 body-2 text-white">{{$t('hotel.action.book-now')}}</p>
											</div>
										</div>
									</div>
								</div>
							</div> -->

              <div
                class="w-100 radius-12"
                :class="
                  !is_load.promo && !is_load.be ? 'border-semi-grey' : ''
                ">
                <!-- PROMO -->
                <div class="w-100">
                  <b-row
                    class="slim-grid-row"
                    v-if="is_load.promo || is_load.be">
                    <b-col cols="12" class="mb-3">
                      <b-card>
                        <b-skeleton width="50%" height="20px"></b-skeleton>
                        <b-skeleton
                          width="70%"
                          height="15px"
                          class="mb-2"></b-skeleton>
                      </b-card>
                    </b-col>
                  </b-row>
                  <template v-else>
                    <template v-if="data_parent.promo.length > 0">
                      <router-link :to="'/' + getMerchant.code + '/promo'">
                        <div
                          class="promo-mobile rounded-top-12 position-relative px-4 py-3">
                          <div class="row no-gutters">
                            <div class="col-1">
                              <div class="d-inline-block icon">
                                <img
                                  src="../../assets/img/icon/menu-navbar/Promo.svg"
                                  alt="Promo"
                                  width="42" />
                              </div>
                            </div>
                            <div class="col-10">
                              <div class="d-inline-block ml-3 pl-1">
                                <p class="mb-0 body-1-2 text-16 font-bold">
                                  {{ $t('hotel.concierge.fitur.there-are') }}
                                  {{ data_parent.promo.length }}
                                  {{
                                    $t(
                                      'hotel.concierge.fitur.interesting-promos'
                                    )
                                  }}
                                </p>
                                <p class="mb-0 body-1-2 text-12 font-regular">
                                  {{
                                    $t(
                                      'hotel.concierge.fitur.click-to-get-attractive-promos'
                                    )
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="col-1 text-right">
                              <img
                                src="../../assets/img/icon/back-arrow.png"
                                class="mt-3 transform-180"
                                alt="Promo"
                                width="12" />
                            </div>
                            <div class="bg">
                              <img
                                src="../../assets/img/icon/menu-navbar/Promo-Bg.svg"
                                alt="Promo"
                                class="w-100" />
                            </div>
                          </div>
                        </div>
                      </router-link>
                    </template>
                    <div
                      class="p-xl-4 p-md-3"
                      v-if="show_booking_engine_section">
                      <p class="heading-5 mb-2 text-26">
                        {{ $t('hotel.concierge.fitur.book-our-rooms') }}
                      </p>
                      <template
                        v-if="
                          getMerchant.use_booking_engine &&
                          data_parent.lowest_price > 0
                        ">
                        <p class="body-2-2 mb-0">
                          {{ $t('hotel.starting-from') }}
                        </p>
                        <p class="body-2-2-3 text-18 text-orange mb-3">
                          {{ $formatCurrency(data_parent.lowest_price) }}
                        </p>
                      </template>
                      <p class="mb-2 body-3">
                        {{
                          $t(
                            'hotel.concierge.fitur.click-to-get-attractive-promos'
                          )
                        }}
                      </p>
                      <div
                        class="border-semi-grey radius-12 mb-3"
                        @click="togglePopupFilter()">
                        <div class="w-100 border-b-semi-grey p-3">
                          <div class="row no-gutters">
                            <div class="col-1 align-self-center">
                              <img
                                src="../../assets/img/icon/calendar-dark.png"
                                width="15" />
                            </div>
                            <div class="col-11 align-self-center">
                              <div class="w-100 pl-1">
                                <p class="mb-0 body-3">
                                  {{ $t('hotel.date.check-in') }} -
                                  {{ $t('hotel.date.check-out') }}
                                </p>
                                <p class="mb-0 body-2-1">
                                  {{ $formatDate(getBeFilter.date.check_in) }} -
                                  {{ $formatDate(getBeFilter.date.check_out) }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row no-gutters">
                          <div class="col-6 border-r-semi-grey">
                            <div class="w-100 p-3">
                              <div class="row no-gutters">
                                <div class="col-2 align-self-center">
                                  <img
                                    src="../../assets/img/icon/double-user.png"
                                    width="15" />
                                </div>
                                <div class="col-10 align-self-center">
                                  <div style="padding-left: 4px">
                                    <p class="mb-0 body-3">
                                      {{ $t('hotel.guests.guests') }}
                                    </p>
                                    <p class="mb-0 body-2-1 text-truncate">
                                      {{ getBeFilter.guest.adult }}
                                      {{ $t('hotel.adults.adults')
                                      }}<template
                                        v-if="
                                          getMerchant.search_room_is_show_filter_pax_child
                                        "
                                        >, {{ getBeFilter.guest.child }}
                                        {{
                                          $t('hotel.children.children')
                                        }}</template
                                      ><template
                                        v-if="
                                          getMerchant.search_room_is_show_filter_pax_infant
                                        "
                                        >, {{ getBeFilter.guest.infant }}
                                        {{
                                          $t('hotel.infants.infants')
                                        }}</template
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="w-100 p-3">
                              <div class="row no-gutters">
                                <div class="col-2 align-self-center">
                                  <img
                                    src="../../assets/img/icon/discount-dark.png"
                                    width="15" />
                                </div>
                                <div class="col-10 align-self-center">
                                  <div style="padding-left: 4px">
                                    <p class="mb-0 body-3">
                                      {{ $t('hotel.promo.promo-code') }}
                                    </p>
                                    <p class="mb-0 body-2-1 text-truncate">
                                      {{
                                        getBeFilter.promo_code == ''
                                          ? '-'
                                          : getBeFilter.promo_code
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          getMerchant.use_custom_booking_engine_landing_page
                        "
                        class="w-100 radius-12 bg-green p-3 cursor-pointer text-center"
                        @click="goToBookingPage()">
                        <p class="mb-0 body-2 text-white">
                          {{ $t('hotel.action.book-now') }}
                        </p>
                      </div>
                      <div
                        v-else
                        class="w-100 radius-12 bg-green p-3 cursor-pointer text-center"
                        @click="goToSearchRoom()">
                        <p class="mb-0 body-2 text-white">
                          {{ $t('hotel.action.book-now') }}
                        </p>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div
                class="mt-4 w-100"
                v-if="getMerchant.use_user_menu && !isLoggedIn && !is_load.promo && !is_load.be">
                <router-link :to="'/' + getMerchant.code + '/login'">
                  <div
                    class="promo-mobile border-top-3 hover bg-white border-semi-grey radius-12 position-relative px-4 py-3">
                    <div class="row no-gutters">
                      <div class="col-1">
                        <div class="d-inline-block icon">
                          <svg
                            width="43"
                            height="41"
                            viewBox="0 0 43 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M32.187 14.0568C32.187 18.7928 28.3898 22.5903 23.6505 22.5903C18.9128 22.5903 15.1139 18.7928 15.1139 14.0568C15.1139 9.32086 18.9128 5.525 23.6505 5.525C28.3898 5.525 32.187 9.32086 32.187 14.0568ZM23.6505 37.775C16.6561 37.775 10.7505 36.6382 10.7505 32.2521C10.7505 27.8645 16.6932 26.768 23.6505 26.768C30.6465 26.768 36.5505 27.9048 36.5505 32.2908C36.5505 36.6785 30.6078 37.775 23.6505 37.775Z"
                              class="fill-primary" />
                            <path
                              d="M9.64567 5.28137C9.55286 5.37131 9.51022 5.50139 9.53136 5.62895L9.84992 7.39195C9.8768 7.54138 9.81373 7.69259 9.68867 7.77895C9.56612 7.86854 9.40308 7.87929 9.26942 7.80762L7.68236 6.97987C7.62718 6.95049 7.5659 6.93472 7.50319 6.93293H7.40609C7.3724 6.93794 7.33944 6.94869 7.30934 6.96518L5.72192 7.79687C5.64345 7.83629 5.55458 7.85026 5.4675 7.83629C5.25537 7.79615 5.11383 7.59405 5.14859 7.38084L5.4675 5.61784C5.48865 5.4892 5.446 5.35841 5.3532 5.26704L4.05925 4.01287C3.95104 3.90788 3.91341 3.75021 3.96286 3.60795C4.01088 3.46605 4.13343 3.36249 4.28142 3.3392L6.06234 3.08084C6.19779 3.06687 6.31675 2.98445 6.37767 2.86262L7.16242 1.2537C7.18105 1.21787 7.20506 1.1849 7.23409 1.15695L7.26634 1.13187C7.28318 1.11324 7.30253 1.09783 7.32403 1.08529L7.36309 1.07095L7.424 1.04587H7.57486C7.70959 1.05984 7.8282 1.14047 7.89019 1.26087L8.68534 2.86262C8.74267 2.97979 8.85411 3.06114 8.98275 3.08084L10.7637 3.3392C10.9142 3.3607 11.0399 3.46462 11.0898 3.60795C11.1367 3.75164 11.0962 3.90931 10.9858 4.01287L9.64567 5.28137Z"
                              fill="#FAC02C" />
                            <path
                              d="M3.21053 11.3157C3.16413 11.3607 3.14281 11.4257 3.15338 11.4895L3.31266 12.371C3.32609 12.4457 3.29456 12.5213 3.23203 12.5645C3.17076 12.6093 3.08923 12.6146 3.02241 12.5788L2.22888 12.1649C2.20128 12.1502 2.17065 12.1424 2.13929 12.1415H2.09074C2.0739 12.144 2.05741 12.1493 2.04236 12.1576L1.24866 12.5734C1.20942 12.5931 1.16498 12.6001 1.12145 12.5931C1.01538 12.5731 0.944609 12.472 0.961989 12.3654L1.12145 11.4839C1.13202 11.4196 1.1107 11.3542 1.06429 11.3085L0.417322 10.6814C0.363214 10.6289 0.344401 10.5501 0.369126 10.479C0.393135 10.408 0.45441 10.3562 0.528405 10.3446L1.41886 10.2154C1.48659 10.2084 1.54607 10.1672 1.57653 10.1063L1.96891 9.30185C1.97822 9.28394 1.99023 9.26745 2.00474 9.25348L2.02086 9.24094C2.02928 9.23162 2.03896 9.22391 2.04971 9.21764L2.06924 9.21048L2.0997 9.19794H2.17513C2.24249 9.20492 2.3018 9.24524 2.33279 9.30544L2.73036 10.1063C2.75903 10.1649 2.81475 10.2056 2.87907 10.2154L3.76953 10.3446C3.84478 10.3554 3.90767 10.4073 3.93257 10.479C3.95604 10.5508 3.9358 10.6297 3.88061 10.6814L3.21053 11.3157Z"
                              fill="#FAC02C" />
                            <path
                              d="M7.51082 16.6907C7.46442 16.7357 7.4431 16.8007 7.45367 16.8645L7.61295 17.746C7.62639 17.8207 7.59485 17.8963 7.53232 17.9395C7.47105 17.9843 7.38953 17.9896 7.3227 17.9538L6.52917 17.5399C6.50158 17.5252 6.47094 17.5174 6.43959 17.5165H6.39103C6.37419 17.519 6.35771 17.5243 6.34266 17.5326L5.54895 17.9484C5.50971 17.9681 5.46528 17.9751 5.42174 17.9681C5.31567 17.9481 5.2449 17.847 5.26228 17.7404L5.42174 16.8589C5.43231 16.7946 5.41099 16.7292 5.36459 16.6835L4.71761 16.0564C4.66351 16.0039 4.64469 15.9251 4.66942 15.854C4.69343 15.783 4.7547 15.7312 4.8287 15.7196L5.71916 15.5904C5.78688 15.5834 5.84636 15.5422 5.87682 15.4813L6.2692 14.6769C6.27851 14.6589 6.29052 14.6425 6.30503 14.6285L6.32116 14.6159C6.32958 14.6066 6.33925 14.5989 6.35 14.5926L6.36953 14.5855L6.39999 14.5729H6.47542C6.54279 14.5799 6.60209 14.6202 6.63309 14.6804L7.03066 15.4813C7.05932 15.5399 7.11504 15.5806 7.17936 15.5904L8.06982 15.7196C8.14507 15.7304 8.20796 15.7823 8.23286 15.854C8.25634 15.9258 8.23609 16.0047 8.18091 16.0564L7.51082 16.6907Z"
                              fill="#FAC02C" />
                          </svg>
                        </div>
                      </div>
                      <div class="col-10">
                        <div class="d-inline-block ml-3 pl-1">
                          <p class="mb-0 body-1-2 text-16 font-bold">
                            {{ $t('hotel.concierge.fitur.login.title') }}
                          </p>
                          <p class="mb-0 body-1-2 text-12 font-regular">
                            {{ $t('hotel.concierge.fitur.login.desc') }}
                          </p>
                        </div>
                      </div>
                      <div class="col-1 text-right">
                        <img
                          src="../../assets/img/icon/back-arrow.png"
                          class="mt-3 transform-180"
                          alt="Promo"
                          width="12" />
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="row" v-if="!is_load.bottom">
          <div class="col-12 mb-3">
            <p class="heading-5 mb-0">
              {{ $t('hotel.concierge.fitur.things-to-know') }}
            </p>
          </div>
          <div class="col-4">
            <p class="body-1-2 mb-2">{{ $t('general.information') }}</p>
            <div class="row mb-1">
              <div class="col-1">
                <img src="../../assets/img/icon/location-dark.png" width="15" />
              </div>
              <div class="col-10">{{ getMerchant.address }}</div>
            </div>
            <div class="row mb-1">
              <div class="col-1">
                <img src="../../assets/img/icon/time-dark.png" width="16" />
              </div>
              <div class="col-10">
                <p class="mb-0 body-2-2 font-regular d-inline-block">
                  {{ $t('hotel.check-in-time') }}
                  {{ formatTime(getMerchant.check_in_time_start) }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-1">
                <img src="../../assets/img/icon/time-dark.png" width="16" />
              </div>
              <div class="col-10">
                <p class="mb-0 body-2-2 font-regular d-inline-block">
                  {{ $t('hotel.check-out-time') }}
                  {{ formatTime(getMerchant.check_out_time_end) }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-4">
            <p class="body-1-2 mb-2">
              {{ $t('hotel.concierge.fitur.terms-conditions') }}
            </p>
            <p
              class="body-2-2 text-truncate-4 mb-2"
              style="height: 84px !important"
              v-html="getMerchant.terms_and_conditions"></p>
            <div class="d-table link-green-arrow">
              <p
                class="mb-0 d-inline-block aling-middle"
                @click="
                  togglePopupInfo(
                    $t('hotel.concierge.fitur.terms-conditions'),
                    getMerchant.terms_and_conditions
                  )
                ">
                {{ $t('hotel.concierge.fitur.read-more') }}
              </p>
              <i
                class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12"></i>
            </div>
          </div>
          <div class="col-4">
            <p class="body-1-2 mb-2">
              {{ $t('merchant.cancellation-policy') }}
            </p>
            <p
              class="body-2-2 text-truncate-4 mb-2"
              style="height: 84px !important"
              v-html="getMerchant.cancellation_policy"></p>
            <div class="d-table link-green-arrow ml-auto">
              <p
                class="mb-0 d-inline-block aling-middle"
                @click="
                  togglePopupInfo(
                    $t('merchant.cancellation-policy'),
                    getMerchant.cancellation_policy
                  )
                ">
                {{ $t('hotel.concierge.fitur.read-more') }}
              </p>
              <i
                class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12"></i>
            </div>
          </div>
          <div class="col-12 mt-5">
            <div class="row">
              <div class="col-7">
                <p class="body-2-2">
                  Copyright © {{ year.getFullYear() }}
                  {{ getMerchant.name }} All Right Reserved
                </p>
              </div>
              <div class="col-5 text-right">
                <div @click="toggleShowLanguagePopup(true)">
                  <p
                    class="body-2-2 cursor-pointer d-inline-block aling-middle mr-2">
                    <span>{{ $t('hotel.language') }}</span> |
                    {{ getCurrency.name }} ({{ getCurrency.code }})
                  </p>
                  <i
                    class="iconsmind-Arrow-Down font-weight-bold d-inline-block aling-middle text-12"
                    :class="{ 'transform-180': popup_active }"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- DETAIL BASIC INFORMATION -->
    <popup-detail
      direction="bottom"
      :show="popup_info.show"
      :use_max_size="true"
      :title="popup_info.title"
      @close="togglePopupInfo">
      <template v-slot:body>
        <div class="py-3 px-4">
          <div class="html-desc" v-html="popup_info.body"></div>
        </div>
      </template>
    </popup-detail>

    <!-- DETAIL FILTER BOOKING ENGINE -->
    <popup-detail
      direction="bottom"
      :show="popup_filter.show"
      wrapper_size="mobile"
      :use_max_size="true"
      :use_footer="true"
      title="Book Our Rooms"
      @close="togglePopupFilter">
      <template v-slot:body>
        <div class="px-4">
          <div class="w-100 p-2-5 border-form radius-12 mb-3 hotel-home-calendar">
            <CalendarRoom
              :date_default="popup_filter.form.date"
              :is_double="false"
              :filter_guest="popup_filter.form.guest"
              only_for_page="homepage"
              @finish="applyDateFilter"
              wrapper_class="calendar-be-active body-2-2 font-bold text-14 z-index-1038 w-100"></CalendarRoom>
          </div>
          <div class="w-100 p-2-5 d-flex border-form radius-12 mb-3">
            <svg
              class="mr-2-5 icon"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z"
                fill="#999999" />
            </svg>
            <div class="w-100">
              <p class="mb-0 body-3 mt-1 mb-3 pb-3 w-100 border-b-semi-grey-dashed">
                {{ $t('hotel.guests.guests') }}
              </p>
              <div
                class="row no-gutters w-100"
                :class="{
                  'border-b-semi-grey-dashed mb-3 pb-3':
                    getMerchant.search_room_is_show_filter_pax_child ||
                    getMerchant.search_room_is_show_filter_pax_infant,
                }">
                <div class="col-7">
                  <p class="mb-0 body-2-1">
                    {{ $t('hotel.adults.adults') }}
                  </p>
                  <p class="mb-0 body-3-3-1">
                    {{ getMerchant.adult_description }}
                  </p>
                </div>
                <div class="col-5 text-center mt-1">
                  <div class="row py-1 text-right w-100 no-gutters">
                    <div class="col-4 text-center">
                      <img
                        src="../../assets/img/icon/decrement.png"
                        class="cursor-disable border rounded-100 p-2"
                        width="30"
                        v-if="popup_filter.form.guest.adult <= '1'" />
                      <img
                        src="../../assets/img/icon/minus-black.png"
                        class="cursor-pointer border rounded-100 p-2"
                        width="30"
                        v-else
                        @click="toggleCounter('min', 'adult')" />
                    </div>
                    <div class="col-4 text-center">
                      <p
                        class="mb-0 body-2-2 font-bold text-16 position-relative"
                        style="top: 3px">
                        {{ popup_filter.form.guest.adult }}
                      </p>
                    </div>
                    <div class="col-4 text-center">
                      <img
                        src="../../assets/img/icon/plus-black.png"
                        class="cursor-pointer border rounded-100 p-2"
                        width="30"
                        @click="toggleCounter('plus', 'adult')" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="getMerchant.search_room_is_show_filter_pax_child"
                class="row no-gutters mb-3 pb-3 w-100 border-b-semi-grey-dashed">
                <div class="col-7">
                  <p class="mb-0 body-2-1">
                    {{ $t('hotel.children.children') }}
                  </p>
                  <p class="mb-0 body-3-3-1">
                    {{ getMerchant.children_description }}
                  </p>
                </div>
                <div class="col-5 text-center mt-1">
                  <div class="row py-1 text-right w-100 no-gutters">
                    <div class="col-4 text-center">
                      <img
                        src="../../assets/img/icon/decrement.png"
                        class="cursor-disable border rounded-100 p-2"
                        width="30"
                        v-if="popup_filter.form.guest.child <= '0'" />
                      <img
                        src="../../assets/img/icon/minus-black.png"
                        class="cursor-pointer border rounded-100 p-2"
                        width="30"
                        v-else
                        @click="toggleCounter('min', 'child')" />
                    </div>
                    <div class="col-4 text-center">
                      <p
                        class="mb-0 body-2-2 font-bold text-16 position-relative"
                        style="top: 3px">
                        {{ popup_filter.form.guest.child }}
                      </p>
                    </div>
                    <div class="col-4 text-center">
                      <img
                        src="../../assets/img/icon/plus-black.png"
                        class="cursor-pointer border rounded-100 p-2"
                        width="30"
                        @click="toggleCounter('plus', 'child')" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="getMerchant.search_room_is_show_filter_pax_infant"
                class="row no-gutters">
                <div class="col-7">
                  <p class="mb-0 body-2-1">
                    {{ $t('hotel.infants.infants') }}
                  </p>
                  <p class="mb-0 body-3-3-1">
                    {{ getMerchant.infant_description }}
                  </p>
                </div>
                <div class="col-5 text-center mt-1">
                  <div class="row py-1 text-right w-100 no-gutters">
                    <div class="col-4 text-center">
                      <img
                        src="../../assets/img/icon/decrement.png"
                        class="cursor-disable border rounded-100 p-2"
                        width="30"
                        v-if="popup_filter.form.guest.infant <= '0'" />
                      <img
                        src="../../assets/img/icon/minus-black.png"
                        class="cursor-pointer border rounded-100 p-2"
                        width="30"
                        v-else
                        @click="toggleCounter('min', 'infant')" />
                    </div>
                    <div class="col-4 text-center">
                      <p
                        class="mb-0 body-2-2 font-bold text-16 position-relative"
                        style="top: 3px">
                        {{ popup_filter.form.guest.infant }}
                      </p>
                    </div>
                    <div class="col-4 text-center">
                      <img
                        src="../../assets/img/icon/plus-black.png"
                        class="cursor-pointer border rounded-100 p-2"
                        width="30"
                        @click="toggleCounter('plus', 'infant')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 p-2-5 d-flex align-items-center border-form radius-12 mb-3">
            <svg
              class="mr-2-5"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.399 9.146l.72.72c.571.56.881 1.32.881 2.12.01.8-.3 1.561-.86 2.13l-.01.01-.71.71c-.28.28-.44.66-.44 1.061v1.03c0 1.66-1.35 3.011-3.011 3.011h-1.03c-.4 0-.78.16-1.061.44l-.72.72c-.59.591-1.36.88-2.131.88-.77 0-1.54-.289-2.13-.869l-.73-.731c-.28-.28-.66-.44-1.061-.44h-1.03c-1.66 0-3.011-1.351-3.011-3.011v-1.03c0-.401-.16-.781-.44-1.071l-.72-.71c-1.17-1.17-1.18-3.081-.01-4.26l.73-.731c.28-.28.44-.66.44-1.07v-1.02c0-1.66 1.35-3.011 3.011-3.011h1.03c.4 0 .78-.161 1.06-.441l.721-.72c1.17-1.18 3.08-1.18 4.26-.01l.73.73c.28.28.66.44 1.06.44h1.03c1.66 0 3.011 1.35 3.011 3.011v1.031c0 .4.16.78.44 1.06ZM9.425 15.446c.24 0 .46-.09.62-.26l5.142-5.139c.34-.34.34-.901 0-1.241s-.891-.341-1.231 0l-5.142 5.14c-.34.34-.34.9 0 1.24.16.17.38.26.611.26Zm4.272-.88c0 .49.39.88.88.88.48 0 .87-.39.87-.88 0-.48-.39-.87-.87-.87s-.88.39-.88.87ZM9.435 8.556c.48 0 .87.39.87.87 0 .491-.39.88-.87.88s-.88-.389-.88-.88c0-.48.4-.87.88-.87Z"
                fill="#999" />
            </svg>
            <div class="w-100">
              <p class="mb-1 body-3 w-100">
                {{ $t('hotel.promo.promo-code') }}
              </p>
              <input
                type="text"
                class="border-form radius-6 body-2-1 w-100 p-2"
                v-model="popup_filter.form.promo_code" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-4 pt-3">
          <state-button
            block
            variant="primary"
            size="lg"
            :click="goToBookingPage"
            >{{ $t('hotel.action.book-now') }}</state-button
          >
        </div>
      </template>
    </popup-detail>
    <!-- GALLERY -->
    <transition name="fade">
      <template v-if="is_gallery">
        <div class="container">
          <div
            class="fixed-top d-block nav-bottom bg-white pop-up fit-to-screen scroll-hide-mobile z-index-1042 w-100">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="container px-4 pb-4">
                    <div
                      class="position-sticky w-100 bg-white top-0 z-index-1036 py-3">
                      <div class="row">
                        <div class="col-12">
                          <img
                            src="../../assets/img/icon/back.png"
                            class="d-inline-block cursor-pointer"
                            @click="showGallery(false)"
                            width="20" />
                          <p
                            class="mb-0 body-1-2 d-inline-block position-relative ml-1 cursor-pointer"
                            style="top: 1px"
                            @click="showGallery(false)"
                            width="20">
                            {{ $t('general.back') }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row slim-grid-row-1">
                      <div
                        class="col-6 mb-2"
                        :class="{
                          'col-12':
                            index_image_slider == 0 ||
                            index_image_slider == 3 ||
                            index_image_slider == 8,
                        }"
                        v-for="(
                          image_slider, index_image_slider
                        ) in getMerchant.merchant_images"
                        :key="index_image_slider"
                        @click="index = index_image_slider">
                        <img
                          :src="image_slider.image_url"
                          class="object-fit w-100 cursor-pointer"
                          :alt="getMerchant.name"
                          height="400" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CoolLightBox
            :items="getMerchant.merchant_images"
            srcName="image_url"
            :index="index"
            :closeOnClickOutsideMobile="true"
            @close="index = null">
          </CoolLightBox>
        </div>
      </template>
    </transition>
    <!-- <CurrencyAndLanguage @close="handlePopupFilter" v-if="popup_active"></CurrencyAndLanguage> -->
    <!-- PopUp Background -->
    <transition name="fade">
      <template v-if="popup_active">
        <PopUpBackground
          @handlePopupFilter="handlePopupFilter"
          :popup_active="popup_active"></PopUpBackground>
      </template>
    </transition>

    <!-- Currency -->
    <GeneralLanguageCurrency
      :showPopup="showLanguagePopup"
      @togglePopup="toggleShowLanguagePopup" />

    <!-- GUEST BILL -->
    <GuestBill ref="guest_bill"></GuestBill>

    <b-modal 
      id="facilities-modal"
      size="lg"
      title-class="body-1-2"
      title="Facilities"
      hide-footer>
      <div class="row slim-grid-row">
        <div
          class="col-sm-3 col-6 mb-3"
          v-for="(facility, index) in getMerchant.facilities">
          <Facility :data="facility"></Facility>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { calculateFinalPriceConcierge } from '@/utils/index.js';
import moment from 'moment';
import Flickity from 'vue-flickity';
import RoomDiningPreview from '@/components/hotel/general/RoomDiningPreview';
import ThingsToDoPreview from '@/components/hotel/general/ThingsToDoPreview';
import SpaPreview from '@/components/hotel/general/SpaPreview';
import LaundryPreview from '@/components/hotel/general/LaundryPreview';
import CustomUrl from '@/components/hotel/general/CustomUrl';
import Facility from '@/components/hotel/general/Facility';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import CurrencyAndLanguage from '@/components/hotel/be/desktop/CurrencyAndLanguage';
import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
import CalendarRoom from '@/components/hotel/be/CalendarRoom';
import VoucherPreview from '@/components/hotel/general/VoucherPreview';
import GuestBill from '@/components/hotel/general/GuestBill';
import HomeNavbar from '@/components/hotel/be/desktop/HomeNavbar';
import config from '@/config/index.js';
import RoomTypePreview from '@/components/hotel/general/RoomTypePreview';
import PartnerPreview from '@/components/hotel/general/PartnerPreview';
import GeneralLanguageCurrency from '../../components/general/GeneralLanguageCurrency.vue';

export default {
  props: ['data_parent'],
  components: {
    Flickity,
    RoomDiningPreview,
    ThingsToDoPreview,
    SpaPreview,
    LaundryPreview,
    CustomUrl,
    Facility,
    DateRangePicker,
    CoolLightBox,
    CurrencyAndLanguage,
    PopUpBackground,
    CalendarRoom,
    VoucherPreview,
    GuestBill,
    HomeNavbar,
    RoomTypePreview,
    PartnerPreview,
    GeneralLanguageCurrency,
  },
  data() {
    return {
      config: config,
      topSliderOption: {
        initialIndex: 0,
        autoPlay: 3000,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: false,
        draggable: true,
        wrapAround: true,
      },
      freeScrollSlider: {
        initialIndex: 0,
        autoPlay: 5000,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: false,
        draggable: true,
        wrapAround: false,
        contain: true,
        cellAlign: 'left',
      },
      popup_info: {
        show: false,
        title: '',
        body: '',
      },
      popup_filter: {
        show: false,
        form: {
          date: {
            startDate: moment().toDate(),
            endDate: moment(moment().add(1, 'd')).toDate(),
          },
          guest: {
            adult: 2,
            child: 0,
            infant: 0,
          },
          promo_code: '',
        },
        date_avlb_filter: [],
        date_month_active: [],
        min_date: moment().subtract(1, 'd').toDate(),
      },
      is_gallery: false,
      index: null,
      popup_active: false,
      year: new Date(),
      reservation_pin: '',
      reservation_pin_error: '',
      showLanguagePopup: false,
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getBeFilter',
      'getCurrency',
      'getCurrentLanguage',
      'getMerchantTimezone',
      'isLoggedIn',
      'isCurrentUserSameWithRsvUser',
      'isReservationActive',
    ]),
    reservation_status() {
      if (this.data_parent.reservation.id) {
        let return_data = {
          title: '',
          text_color: '',
          description: '',
        };

        if (this.data_parent.reservation.status == 'SUBMIT_FORM') {
          return_data = {
            title: 'Waiting for Approval',
            text_color: 'text-secondary',
            description:
              'Your data is waiting for approval by the front office. Please wait until the process done.',
          };
        } else if (
          this.data_parent.reservation.status == 'PRE_CHECKIN' ||
          this.data_parent.reservation.status == 'CHECKIN'
        ) {
          return_data = {
            title:
              this.data_parent.reservation.status == 'PRE_CHECKIN'
                ? 'Pre Check In'
                : 'Check In',
            text_color:
              this.data_parent.reservation.status == 'PRE_CHECKIN'
                ? 'text-info'
                : 'text-success',
            description:
              'Make yourself comfortable and enjoy all the services we have provided for you.',
          };
          if (this.isLoggedIn) {
            if (!this.isCurrentUserSameWithRsvUser) {
              return_data.description =
                'This reservation is connected to a guestaps account that is different from your current account. If you want to log in with that account, you can open a message containing the auto login url in your email';
            }
          } else {
            return_data.description =
              'Your data has been validated. There are many offers if you log in with a Guestaps account, please check your email for automatic login to your Guestaps account';
          }
        }

        return return_data;
      } else {
        return null;
      }
    },
    show_booking_engine_section() {
      if (this.isReservationActive || !this.getMerchant.use_booking_engine)
        return false;
      else return true;
    },
    is_load() {
      return this.data_parent.loading_section;
    },
    facilitiesInline(){
      const { facilities = [] } = this.getMerchant;
      if(this.$isEmpty(facilities)) return [];

      const totalItemToShow = 8;
      return facilities.length >= totalItemToShow ? facilities.slice(0, totalItemToShow - 1) : facilities;
    }
  },
  methods: {
    ...mapMutations(['setBeFilter']),
    toggleShowLanguagePopup(show = false) {
      this.showLanguagePopup = show;
    },
    openGuestBill() {
      this.$refs.guest_bill.toggleDetail();
    },
    callClick() {
      this.$emit('callClick');
    },
    formatTime(time) {
      return moment(time, 'HH:mm:ss').format('HH:mm');
    },
    detailPromotion() {
      this.$postLog('HOME', 'PROMOTION', 'Clicked promotion');
    },
    goToSearchRoom() {
      this.$postLog('HOME', 'PREVIEW BOOK ROOM', 'Clicked book now');
      this.$router.push(`/${this.getMerchant.code}/booking`);
    },
    printBestMenuPrice(product) {
      let price =
        product.variant_list.length == 0
          ? product.price
          : product.variant_list[0].price;
      return calculateFinalPriceConcierge(price);
    },
    applyDateFilter(date) {
      this.popup_filter.form.date = date;
    },
    shareClick() {
      this.$emit('shareClick');
    },
    togglePopupInfo(title = '', body = '') {
      this.popup_info.show = !this.popup_info.show;
      this.popup_info.title = title;
      this.popup_info.body = body;
      this.$postLog('HOME', 'FOOTER', `Clicked detail ${title}`);
    },
    detailModuleClick(code) {
      this.$emit('detailModuleClick', code);
    },
    goToDetailSlider(slider) {
      this.$emit('goToDetailSlider', slider);
    },
    togglePopupFilter() {
      this.popup_filter.show = !this.popup_filter.show;
      if (this.popup_filter.show) {
        let cloned_data = this.$deepCopy(this.getBeFilter);
        this.popup_filter.form = {
          date: {
            startDate: cloned_data.date.check_in,
            endDate: cloned_data.date.check_out,
          },
          guest: cloned_data.guest,
          promo_code: cloned_data.promo_code,
        };
      } else {
        this.popup_filter.form = {
          date: {
            startDate: moment().toDate(),
            endDate: moment(moment().add(1, 'd')).toDate(),
          },
          guest: {
            adult: 2,
            child: 0,
            infant: 0,
          },
          promo_code: '',
        };
      }
    },
    formatCustomDate(data, frmt) {
      return moment(data).format(frmt);
    },
    goToBookingPage() {
      return new Promise((success, fail) => {
        let use_other_booking_engine =
          this.getMerchant.use_custom_booking_engine_landing_page;
        if (use_other_booking_engine) {
          let parsed_url =
            this.getMerchant.custom_booking_engine_landing_page_url;
          let params = [
            {
              name: 'Checkin Date (DD)',
              parameter: '{{checkin_date}}',
              value: this.formatCustomDate(
                this.popup_filter.form.date.startDate,
                'DD'
              ),
            },
            {
              name: 'Checkin Month (MM)',
              parameter: '{{checkin_month}}',
              value: this.formatCustomDate(
                this.popup_filter.form.date.startDate,
                'MM'
              ),
            },
            {
              name: 'Checkin Year (YYYY)',
              parameter: '{{checkin_year}}',
              value: this.formatCustomDate(
                this.popup_filter.form.date.startDate,
                'YYYY'
              ),
            },
            {
              name: 'Checkout Date (DD)',
              parameter: '{{checkout_date}}',
              value: this.formatCustomDate(
                this.popup_filter.form.date.endDate,
                'DD'
              ),
            },
            {
              name: 'Checkout Month (MM)',
              parameter: '{{checkout_month}}',
              value: this.formatCustomDate(
                this.popup_filter.form.date.endDate,
                'MM'
              ),
            },
            {
              name: 'Checkout Year (YYYY)',
              parameter: '{{checkout_year}}',
              value: this.formatCustomDate(
                this.popup_filter.form.date.endDate,
                'YYYY'
              ),
            },
            {
              name: 'Total Night Stay',
              parameter: '{{total_night}}',
              value: moment
                .duration(
                  moment(this.popup_filter.form.date.endDate).diff(
                    moment(this.popup_filter.form.date.startDate)
                  )
                )
                .days(),
            },
            {
              name: 'Total Adult',
              parameter: '{{total_adult}}',
              value: this.popup_filter.form.guest.adult,
            },
            {
              name: 'Total Child',
              parameter: '{{total_child}}',
              value: this.popup_filter.form.guest.child,
            },
            {
              name: 'Total Infant',
              parameter: '{{total_infant}}',
              value: this.popup_filter.form.guest.infant,
            },
            {
              name: 'Total Guest',
              parameter: '{{total_guest}}',
              value:
                Number(this.popup_filter.form.guest.adult) +
                Number(this.popup_filter.form.guest.child) +
                Number(this.popup_filter.form.guest.infant),
            },
            {
              name: 'Currency in ISO format',
              parameter: '{{currency_code}}',
              value: this.getCurrency.code,
            },
            {
              name: 'Language Used',
              parameter: '{{langugae_code}}',
              value: this.getCurrentLanguage,
            },
            {
              name: 'Promo Code',
              parameter: '{{promo_code}}',
              value: this.popup_filter.form.promo_code,
            },
          ];
          params.forEach((item) => {
            parsed_url = parsed_url.replaceAll(item.parameter, item.value);
          });
          this.$openLink(parsed_url, '_blank');
          success();
        } else {
          setTimeout(() => {
            let params = {
              date: {
                check_in: this.popup_filter.form.date.startDate,
                check_out: this.popup_filter.form.date.endDate,
              },
              guest: this.popup_filter.form.guest,
              promo_code: this.popup_filter.form.promo_code,
            };
            this.setBeFilter(params);
            this.goToSearchRoom();
            success();
          }, 300);
        }
      });
    },
    toggleCounter(data, category) {
      if (data == 'plus' && category == 'adult') {
        this.popup_filter.form.guest.adult++;
      } else if (data == 'min' && category == 'adult') {
        this.popup_filter.form.guest.adult--;
        if (this.popup_filter.form.guest.adult <= 0) {
          this.popup_filter.form.guest.adult = 0;
        }
      } else if (data == 'plus' && category == 'child') {
        this.popup_filter.form.guest.child++;
      } else if (data == 'min' && category == 'child') {
        this.popup_filter.form.guest.child--;
        if (this.popup_filter.form.guest.child <= 0) {
          this.popup_filter.form.guest.child = 0;
        }
      } else if (data == 'plus' && category == 'infant') {
        this.popup_filter.form.guest.infant++;
      } else if (data == 'min' && category == 'infant') {
        this.popup_filter.form.guest.infant--;
        if (this.popup_filter.form.guest.infant <= 0) {
          this.popup_filter.form.guest.infant = 0;
        }
      }
    },
    showGallery(data) {
      this.is_gallery = data;
      document.querySelector('body').style.overflow = data ? 'hidden' : 'auto';
    },
    handlePopupFilter() {
      this.popup_active = !this.popup_active;
    },
    openGmaps() {
      let tag_a = document.createElement('a');
      tag_a.href = `https://maps.google.com/?q=${this.getMerchant.lat},${this.getMerchant.lng}`;
      tag_a.target = '_blank';
      tag_a.click();
      tag_a.remove();
    },
    checkStatus() {
      this.$emit('checkReservationStatus');
    },
  },
};
</script>
<style>
.w-40 {
  width: 40% !important;
}
.w-120px {
  width: 120px;
}
.top-100 {
  top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/HotelHomePageDesktop.vue